import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery' ; 
import { Router } from '@angular/router';

@Component({
  selector: 'movie-slider',
  templateUrl: './movie-slider.component.html',
  styleUrls: ['./movie-slider.component.css']
})
export class MovieSliderComponent implements OnInit {

  constructor(private _router:Router) { }

  ngOnInit() {

    

  }
  search()
  {
    var searchValue = (<HTMLInputElement>document.getElementById('searchValue')).value ; 
    (<HTMLInputElement>document.getElementById('searchValue')).value = "" 
    this._router.navigate(["/Movie/Search",searchValue.toUpperCase()]);

  }
  changeSchedule(Day)
  {
    this._router.navigate(["/schedule",Day])
  }

}
